import styled from 'styled-components';
import { media } from '../../../utils/media';

const WelcomeRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 30px 0;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  width: 100%;

  ${media.lessThan('bigTablet')} {
    gap: 24px;
    align-items: flex-start;
  }
  ${media.lessThan('tablet')} {
    flex-direction: column;
    margin: 40px 0;
  }
`;

export default WelcomeRow;
